import { Box, Flex } from "@chakra-ui/react";

import { User } from "@nens/rana/api-v1";

import { Profile } from "../profile";

import { ProfileListModal } from "./profile-list-modal";

export function ProfileStack({ users, boxSize = 8 }: { users?: User[]; boxSize?: number }) {
  const calculateTransform = (index: number) => `translateX(-${index * ((boxSize * 4) / 1.7)}px)`;
  const onlyOneUser = users?.length === 1;
  return (
    <ProfileListModal noModal={onlyOneUser} users={users}>
      <Flex>
        {users?.map((user, index) => {
          if (index < 3)
            return (
              <Box
                key={user.email + user.id}
                position="relative"
                zIndex={users.length - index}
                transform={calculateTransform(index)}
              >
                <Profile noModal={!onlyOneUser} boxSize={boxSize} user={user} />
              </Box>
            );
          if (index === 3)
            return (
              <Flex
                key={user.email + user.id}
                boxSize={boxSize}
                transform={calculateTransform(index - 0.9)}
                alignItems="center"
                justifyContent="center"
              >
                +{users.length - 3}
              </Flex>
            );

          return null;
        })}
      </Flex>
    </ProfileListModal>
  );
}
